<template>
  <ok-cancel-close-modal
    v-if="showAcceptModal"
    :okButton="$t('commons.save')"
    :cancelButton="$t('explorer.reset')"
    v-on:ok="onOk"
    v-on:cancel="onCancel"
    v-on:close="onClose"
    :title="$t('explorer.evolutionOptions.fixedAxes')">
    <div slot="body" class="range-form">
      <label-input
        :label="$t('explorer.min')"
        v-model="range[0]"
        type="number"
        class="range-input"
        :errorMessage="$t('explorer.rangeErrorMin')"
        :error="error"/>
      <label-input
        :label="$t('explorer.max')"
        v-model="range[1]"
        type="number"
        class="range-input"
        :errorMessage="$t('explorer.rangeErrorMax')"
        :error="error"/>
    </div>
  </ok-cancel-close-modal>
</template>

<script>
import OkCancelCloseModal from '@/components/shared/dialogs/OkCancelCloseModal';
import LabelInput from '@/components/shared/forms/LabelInput';

export default {
  components: {
    OkCancelCloseModal,
    LabelInput
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showAcceptModal: false,
      range: [],
      error: false,
      max: Math.max(),
      min: Math.min(),
      userSaveRange: false
    };
  },
  watch: {
    data: {
      handler () {
        const variables = this.data.variables;

        let max = Math.max();
        let min = Math.min();
        if (variables) {
          for (let i = 0; i < variables.length; i++) {
            for (let j = 0; j < variables[i].data.length; j++) {
              max = Math.max(max, variables[i].data[j].value);
              min = Math.min(min, variables[i].data[j].value);
            }
          }
        }

        this.max = max;
        this.min = min;

        if (!this.userSaveRange) {
          this.range = [String(min), String(max)];
        }
      },
      deep: true
    }
  },
  methods: {
    show () {
      this.error = false;
      this.showAcceptModal = true;
    },
    setRange (range) {
      if (range && range.length === 2) {
        this.range = range;
        this.userSaveRange = true;
      }
    },
    onOk () {
      this.error = !this.range[0] || !this.range[1] || Number(this.range[0]) >= Number(this.range[1]);

      if (!this.error) {
        this.showAcceptModal = false;
        this.emitSetChange();
      }
    },
    onCancel () {
      this.showAcceptModal = false;
      this.emitUnsetChange();
    },
    onClose () {
      this.showAcceptModal = false;
      if (this.error) {
        this.emitUnsetChange();
      }
    },
    emitSetChange () {
      this.userSaveRange = true;
      this.$emit('change', [Number(this.range[0]), Number(this.range[1])]);
    },
    emitUnsetChange () {
      this.userSaveRange = false;
      this.range = [String(this.min), String(this.max)];
      this.$emit('change', []);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  .range-form {
    display: flex;
  }

  .range-input {
    width: 50%;
    margin-right: $sp-margin-small;
    margin-left: $sp-margin-small;
  }
</style>



// WEBPACK FOOTER //
// src/components/explorer/evolution/FixedRangeModal.vue